import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { HemView } from "../VIEW/HemView";
import { useAuth } from "../FIREBASE/useAuth";
import routeUrls from "../COMPONENTS/navbar/navLink";

function HemPage() {
  const { user, loading } = useAuth();
  const history = useHistory();

  useEffect(() => {
    if (!loading && !user) history.replace(`${routeUrls.LOGIN}?from=${routeUrls.HEM}`);
  }, [user, loading]);

  if (loading || !user) return null;
  return <HemView uid={user.uid} email={user.email || ""} />;
}

export default HemPage;
